import { PardotPicklistValue } from './PardotPicklistValue';
import React from 'react';
import { useQueryResource } from '@hooks';
import { keyPaginationDefaultQueryParams, keyPaginationFallbackQueryParams } from '@ui/KeyPagination';
import { PeriscopeSearch, PeriscopeV3PaginatedList } from '..';
const renderPicklistValue = (picklistValue) => React.createElement(PardotPicklistValue, { key: picklistValue.internalName, picklistValue: picklistValue });
export const PardotPicklistValueList = ({ uri }) => {
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: keyPaginationDefaultQueryParams,
        fallbackParams: keyPaginationFallbackQueryParams,
        uri
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PeriscopeSearch, { onChange: updateParams }),
        React.createElement(PeriscopeV3PaginatedList, { loading: loading, onChange: updateParams, queryParams: queryParams, renderListItem: renderPicklistValue, resource: resource })));
};
